import styled, { css } from 'styled-components';
import {
	basicColor,
	fadeIn,
	radius,
	transition
} from '@/styles/template';
import FlexContainer from '@/components/molecules/FlexContainer';
import { AccentTextS } from '@/pages/designSystem/Fonts';
import Icon from '@/components/atoms/UI/Icon/Icon';
import { ReactNode } from 'react';

export const WidgetPricingItemWrap = styled.div<{ isPopup?: boolean }>`
  color: ${props => props.theme.color.Text};
  min-width: fit-content;
  overflow: hidden;
  background: ${props => props.theme.color.Item};
  border-radius: ${radius.large};
  position: relative;
  padding: 3rem;
  cursor: ${({ isPopup }) => (isPopup ? 'pointer' : 'default')};
  transition: all ${transition.fastEnd};
  

  &:hover {
    box-shadow: ${({ isPopup, theme }) =>
	isPopup ? theme.boxShadow.Long : 'none'};
  }

  &.active {
    background: ${basicColor.primary};
    color: ${basicColor.white};
    animation: ${fadeIn} .6s cubic-bezier(0.280, 0.840, 0.420, 1);
  }
`;

export const WidgetHeader = styled(FlexContainer)<{ isActive?: boolean }>``;

export const HeaderTitle = styled.div<{ isActive?: boolean }>`
  color: ${({ isActive }) => (isActive ? basicColor.white : basicColor.primary)};
  white-space: nowrap;
`;

export const Price = styled.div`
  white-space: nowrap;
`;


export const DemoButton = styled.a<{ isActive?: boolean }>`
  position: absolute;
  right: 0;
  bottom: 0;
  background:  ${({ isActive, theme }) => (isActive ? basicColor.white : theme.color.LightItem)};
  border-radius: 3rem 0 0 0;
  transition: background-color ${transition.fastEnd};

  &:hover {
    background-color: ${basicColor.white};
  }
`;

export const Selected = styled(AccentTextS)`
	white-space: nowrap;
`;

